import React, { Component } from "react";
import Card from "../../components/Card";
import Action from "../../components/Action";
import AnyOfTheseQuestion from "../../components/AnyOfTheseQuestion";
import RadioQuestion from "../../components/RadioQuestion";
import ScrollToTop from "../../components/utils/ScrollToTop";
import { BUYING_REJECTION_OPTIONS, YES_NO_OPTIONS } from "../../constants";
import Image from "../../components/Image";
import imageCatAndHousePlant from "../../images/cat-and-houseplant.png";

class BuyingPropertyDetails extends Component {
  constructor(props) {
    super(props);

    this.state = {
      propertyOfferAccepted: this.props.buyingPropertyOfferAccepted ?? null,
      buyingRejectionReason: this.props.buyingRejectionReason ?? new Map(),
      errors: {},
      errorMessages: {
        propertyOfferAccepted: "Have you had an offer accepted?",
        rightToBuy: "Let us know if you’re buying through Right to Buy or Right to Acquire",
      },
    };
  }

  handleValidation() {
    const fields = { ...this.state };
    const errorMessages = { ...this.state.errorMessages };

    let errors = {};
    let formIsValid = true;

    if (fields["propertyOfferAccepted"] === null) {
      const field = "propertyOfferAccepted";
      formIsValid = false;
      errors[field] = errorMessages[field];
    }
    if (!this.props.clientIsCompany && this.state.buyingRejectionReason.get("rightToBuy") == null) {
      formIsValid = false;
      errors.rightToBuy = errorMessages.rightToBuy;
    }
    if (
      this.state.propertyOfferAccepted &&
      BUYING_REJECTION_OPTIONS.some((option) => this.state.buyingRejectionReason.get(option.name) == null)
    ) {
      formIsValid = false;
      errors.buyingRejectionReason = true;
    }
    this.setState({ errors });
    return formIsValid;
  }

  handleFieldValidation = (field) => (event) => {
    const isBlur = event.type === "blur";
    this.setState((prevState) => {
      let errors = { ...prevState.errors };
      const errorMessages = { ...prevState.errorMessages };

      if (!isBlur) {
        errors[field] = null;
      } else {
        if (!prevState[field]) {
          errors[field] = errorMessages[field];
        }
      }

      return { errors };
    });
  };

  selectPropertyOffer = (po) => {
    this.setState({ propertyOfferAccepted: po });
  };

  selectRightToBuy = (rightToBuy) => {
    this.setState((prevState) => ({
      buyingRejectionReason: prevState.buyingRejectionReason.set("rightToBuy", rightToBuy),
      errors: { ...prevState.errors, rightToBuy: null },
    }));
  };

  handleBuyingRejectionReason = (answers) => {
    this.setState((prevState) => ({
      buyingRejectionReason: new Map([...prevState.buyingRejectionReason, ...Object.entries(answers)]),
      errors: { ...prevState.errors, buyingRejectionReason: null },
    }));
  };

  shouldReject = () => {
    for (let checked of this.state.buyingRejectionReason.values()) {
      if (checked === true) {
        return true;
      }
    }
    return false;
  };

  saveBuyingPropertyDetails = (event) => {
    event.preventDefault();
    if (this.handleValidation()) {
      this.props.onStepComplete({
        buyingPropertyOfferAccepted: this.state.propertyOfferAccepted,
        buyingRejectionReason: this.state.buyingRejectionReason,
        shouldReject: this.shouldReject(),
      });
      return;
    }
  };

  render() {
    const cardTitle =
      this.props.transactionType === "BuyingAndSelling"
        ? "Tell us about the property you are buying"
        : "Let’s start with the basics";
    return (
      <React.Fragment>
        <ScrollToTop />
        <Card title={cardTitle} removeTopPadding>
          <RadioQuestion
            question={
              this.props.clientIsCompany
                ? "Has your company had an offer accepted on a specific property yet?"
                : "Have you had an offer accepted?"
            }
            options={YES_NO_OPTIONS}
            inline={true}
            name="propertyOfferAccepted"
            selected={this.state.propertyOfferAccepted}
            optionSelected={this.selectPropertyOffer}
            validate={this.handleFieldValidation("propertyOfferAccepted")}
            validationError={this.state.errors.propertyOfferAccepted ? this.state.errors.propertyOfferAccepted : null}
          />

          {/* A company can’t buy through Right to Buy */}
          {!this.props.clientIsCompany && (
            <RadioQuestion
              question="Are you a tenant buying the home you rent from a council or housing association?"
              hint="This is the Right to Buy or Right to Acquire scheme"
              options={YES_NO_OPTIONS}
              inline={true}
              name="rightToBuy"
              selected={this.state.buyingRejectionReason.get("rightToBuy")}
              optionSelected={this.selectRightToBuy}
              validationError={this.state.errors.rightToBuy ? this.state.errors.rightToBuy : null}
            />
          )}

          {this.state.propertyOfferAccepted && (
            <AnyOfTheseQuestion
              options={BUYING_REJECTION_OPTIONS}
              fields={Object.fromEntries(this.state.buyingRejectionReason)}
              onChange={this.handleBuyingRejectionReason}
              invalid={!!this.state.errors.buyingRejectionReason}
            />
          )}

          <Action onClick={this.saveBuyingPropertyDetails}>Continue</Action>
        </Card>
        <Image src={imageCatAndHousePlant} />
      </React.Fragment>
    );
  }
}

export default BuyingPropertyDetails;
